import { TABLE_EVENT_TYPE } from "../../../core/TABLE_EVENT_TYPE";

export function bindDropdownMenuEvent(table) {
    table.on(TABLE_EVENT_TYPE.DROPDOWN_MENU_CLICK, (() => {
        table.stateManager.hideMenu();
    })), table.on(TABLE_EVENT_TYPE.SCROLL, (() => {
        table.stateManager.hideMenu();
    }));
}
//# sourceMappingURL=dropdown-menu.js.map
